import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateUser } from '../redux/userSlice';
import { useHistory } from 'react-router-dom';
import signupimage from '../images/signupimage.jpeg';
import logo from "../images/logo.png";

const SignUp = () => {

    const dispatch = useDispatch();
    const history = useHistory();
    const [errors, setErrors] = useState([])
    const [formData, setFormData] = useState({
        full_name: "",
        username: "",
        email: "",
        phone: "",
        city: "",
        bio:"",
        password:"",
      });

    const handleChange = (e) => {
        setFormData({
          ...formData,
          [e.target.name]: e.target.value,
        });
      }

    
  const handleSubmit = (e) => {
    e.preventDefault();
    fetch("https://fotoset.herokuapp.com/signup", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((r) => {
        return r.json().then((data) => {
          if (r.ok) {
            return data;
          } else {
            throw data;
          }
        });
      })
      .then((data) => {
        const { user, token } = data;
        localStorage.setItem("token", token);
        dispatch(updateUser(user));
        history.push("/");
        setTimeout(function(){
          window.location.reload()
        }, 0)
      })
      .catch((error) => {
        setErrors(error.errors);
      });
  }

  const { full_name, username, email, phone, city, password} = formData;

    return(
<div className="login-page">
    <div className="login-form">
        <div className="login-left">
              <img src={signupimage} alt="login img" />
        </div>
        <div className="form-box-right">
            <form onSubmit={handleSubmit}>
            <img src={logo} alt="Home" className="signup-icon"/>
                <h1 id="signup-text">Join Our Community!</h1><br></br>
                <input
                    type="text"
                    name="full_name"
                    className="signup-input"
                    value={full_name}
                    onChange={handleChange}
                    placeholder="Full Name"
                    required/><br></br>

                <input
                    type="text"
                    name="username"
                    className="signup-input"
                    value={username}
                    onChange={handleChange}
                    placeholder="Username"
                    required/><br></br>

                <input
                    type="text"
                    name="email"
                    className="signup-input"
                    value={email}
                    onChange={handleChange}
                    placeholder="Email"
                    required/><br></br>

                <input
                    type="password"
                    name="password"
                    className="signup-input"
                    value={password}
                    onChange={handleChange}
                    placeholder="Password"
                    /><br></br>
  
                <input
                    type="text"
                    name="phone"
                    className="signup-input"
                    value={phone}
                    onChange={handleChange}
                    placeholder="Phone"
                    required/><br></br>

                <input
                    type="text"
                    name="city"
                    className="signup-input"
                    value={city}
                    onChange={handleChange}
                    placeholder="City"
                    required/><br></br>

                    {errors.map(error => 
                    <p style={{ color: "red"}} key={error}>
                    {error}
                    </p>
                    )}

                <input type="submit" value="SIGN UP" className="signup-button" />
            </form>
        </div>
      </div>
    </div>
  );
}


export default SignUp;